import { render, staticRenderFns } from "./PreviewComponent.vue?vue&type=template&id=084ba6bd"
import script from "./PreviewComponent.vue?vue&type=script&lang=js"
export * from "./PreviewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports